/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewlivenow2Inputs */

const en_overviewlivenow2 = /** @type {(inputs: Overviewlivenow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Happening now`)
};

const de_overviewlivenow2 = /** @type {(inputs: Overviewlivenow2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läuft gerade`)
};

/**
* | output |
* | --- |
* | "Happening now" |
*
* @param {Overviewlivenow2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewlivenow2 = /** @type {((inputs?: Overviewlivenow2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewlivenow2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewlivenow2(inputs)
	return de_overviewlivenow2(inputs)
});
export { overviewlivenow2 as "overviewLiveNow" }